const ROUTE_CONSTANTS = {
  ANTIFRAUDE: '/antifraude',
  ANTIFRAUDE_DASHBOARD: '/dashboard-antifraude',
  ANTIFRAUDE_BLOCKED: '/dashboard-antifraude/blocked',
  ANTIFRAUDE_HISTORY_UNLOCK: '/dashboard-antifraude/history-unlock',
  APPLICATION_REVIEW: '/home/application-reviews',
  APPLICATION_DETAILS: '/home/application-details',
  HOME: '/home',
  DUE_DILIGENCE: '/due-diligence',
  DUE_DILIGENCE_RESUME: '/due-diligence-resume',
  DUE_DILIGENCE_LIST: '/due-diligence-list',
  FORBIDDEN: '/forbidden',
  LIVENESS: '/liveness',
  LIVENESS_CAMERA: '/liveness-cam',
  LIVENESS_FAIL: '/liveness-fail',
  LIVENESS_VALIDATE: '/liveness-validate',
  LOGIN: '/',
  MANUAL_ANALISYS_AUDIT: '/manual-analisys-audit',
  NOT_FOUND: '/404',
  OCR: '/ocr',
  OCR_FAIL: '/ocr-fail',
  OCR_PREVIEW: '/ocr-preview',
  OCR_OPTIONS: '/ocr-options',
  OCR_UPLOAD: '/ocr-upload',
  PASSWORD_CREATION: '/create-password',
  PASSWORD_REDEFINE: '/redefine-password',
  PASSWORD_RECOVER: '/password-recover',
  ACCOUNT_CREATION: '/create-account',
  FORGOT_PASSWORD: '/forgot-password',
  EMAIL_SENT: '/email-sent',
  PASSWORD_SUCCESS: '/password-success',
  PROSPECT_DASHBOARD: '/prospect-dashboard',
  QUIZ: '/quiz',
  QUIZ_START: '/quiz-start',
  QUIZ_FAIL: '/quiz-fail',
  QUIZ_FINISHED: 'quiz-finished',
  RESULT: '/result',
  STATISTICS: '/statistics',
  START: '/start',
  VALID_FAIL: '/failed',
  VERIFY_SIGNATURE: '/antifraude',
  BACKGROUND_CHECK: '/background-check',
  RESTRICTIONS_OPTIONS: '/config/restrictions',
  USER_MANAGEMENT: '/user-management',
  USER_EDITOR: '/user-editor',
}
export {
  ROUTE_CONSTANTS,
}
